import React, { Fragment, useState } from 'react';
import { Row, Col, Table} from 'reactstrap';
import formatedDateOnly from '../../../../../utilities/formatedDateOnly';
import { checkAPIClientConfigStatus } from '../../../../../utilities/checkClientConfig';


const VehicleDetails = ({ data }) => {
  const [allowFuelAndTransmission]  = useState(checkAPIClientConfigStatus(data?.clientConfiguration,"FUEL_TRANSMISSION_REQUIRED") ? true : false)
    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table >
                        <tbody>
                            <tr>
                                <th>VIN</th>
                                <td>{data?.vehicle?.vin}</td>
                            </tr>
                            <tr>
                                <th>Sale Date</th>
                                <td>{ formatedDateOnly(data?.vehicle?.sale_date)}</td>
                            </tr>
                            <tr>
                                <th>Registration No</th>
                                <td>{ data?.vehicle?.registration_no}</td>
                            </tr>
                            <tr>
                                <th>Brand</th>
                                <td>{data?.brand?.name}</td>
                            </tr>
                            <tr>
                                <th>Model</th>
                                <td>{data?.model?.name}</td>
                            </tr>
                            <tr>
                                <th>Variant</th>
                                <td>{data?.variant?.name}</td>
                            </tr>
                            {allowFuelAndTransmission && (
                                <>
                                    <tr>
                                        <th>Fuel</th>
                                        <td>{data?.fuel?.name}</td>
                                    </tr>
                                    <tr>
                                        <th>Transmission</th>
                                        <td>{data?.transmission?.name}</td>
                                    </tr>
                                </>    
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default VehicleDetails;